import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from "@angular/common/http";
import {UserService} from "./user.service";
import {BaseService} from "./_base.service";
import { catchError, Observable, throwError } from 'rxjs';
import { SafeUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class PDFService extends BaseService{

  constructor(http: HttpClient, userService: UserService) {
    super()
  }
  getOrder(id,name){
    const url = this.apiURL + '/pdf/'+id+'/order?auth_token='+this.userService.token+'&device='+localStorage.getItem('MachineId');
    var link = document.createElement('a');
    link.href = url;
    link.download = name+".pdf";
    link.target = "_blank"
    link.click();
  }
  getBudget(id, name, disposition = 'attachment'){
    const url = `${this.apiURL}/pdf/${id}/budget?auth_token=${this.userService.token}&device=${localStorage.getItem('MachineId')}&disposition=${disposition}`;
    var link = document.createElement('a');
    link.href = url;
    link.download = name+".pdf";
    link.target = "_blank"
    link.click();
  }

  getPDF(url: any): Observable<Blob> {
    console.log(url);
    return this.http.get(url, { responseType: 'blob' }).pipe(
      catchError((error) => {
        console.error('Error downloading PDF:', error);
        return throwError(() => error);
      }),
    );
  }
}
